export const MESSAGE_TYPES = {
  MESSAGE: "MESSAGE",
  NOTIFICATION: "NOTIFICATION",
};
